
import { ButtonGroup } from 'element-ui'

export default {
  extends: ButtonGroup,
}
